import React, { Component } from 'react';

import CreatableSelect from 'react-select/creatable';
import PropTypes from 'prop-types';

const components = {
  DropdownIndicator: null,
};

const createOption = (label) => ({
  label,
  value: label,
});

export default class SkillTagInput extends Component {
  state = {
    inputValue: '',
    value: this.props.preSkills,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.preSkills !== this.props.preSkills) {
      this.setState({
        inputValue: '',
        value: this.props.preSkills,
      });
    }
  }

  handleChange = (value, actionMeta) => {
    // console.log('this is preskills in tag ', this.props.preSkills);

    console.group('Value Changed');
    // console.log(value);
    // console.log(`action: ${actionMeta.action}`);
    if (actionMeta.action == 'clear') {
      this.props.skillsTag([]);
    }
    console.groupEnd();
    this.setState({ value }, () => this.props.skillsTag(this.state.value));
  };

  handleInputChange = (inputValue) => {
    const skills = inputValue;
    this.setState({ inputValue });

    if (inputValue.includes(',') && inputValue.length > 1) {
      let arrayOfSkills = skills.split(',').map((test) => {
        return { label: test, value: test };
      });
      arrayOfSkills = arrayOfSkills.filter((skill) => skill.value !== '');
      const { inputValue, value } = this.state;
      this.setState(
        {
          inputValue: '',
          value: [...value, ...arrayOfSkills],
        },
        () => this.props.skillsTag(this.state.value),
      );
    }
  };

  handleKeyDown = (event) => {
    const { inputValue, value } = this.state;
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        console.group('Value Added');
        // console.log('this is key', event.key);
        // console.log(value);
        console.groupEnd();
        this.setState(
          {
            inputValue: '',
            value: [...value, createOption(inputValue)],
          },
          () => this.props.skillsTag(this.state.value),
        );
        event.preventDefault();
    }
  };

  onBlurAdd = (inputValue) => {
    const { value } = this.state;
    if (!inputValue) return;
    this.setState(
      {
        inputValue: '',
        value: [...value, createOption(inputValue)],
      },
      () => this.props.skillsTag(this.state.value),
    );
  };
  render() {
    const { inputValue, value } = this.state;
    return (
      <CreatableSelect
        components={components}
        inputValue={inputValue}
        onBlur={() => {
          this.onBlurAdd(inputValue);
        }}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={this.handleChange}
        onInputChange={this.handleInputChange}
        onKeyDown={this.handleKeyDown}
        placeholder="Score or keywords"
        value={value}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: this.props.error ? 'red' : 'grey',
            minWidth: 400,
          }),
        }}
      />
    );
  }
}

SkillTagInput.propTypes = {
  preSkills: PropTypes.any,
  skillsTag: PropTypes.any,
  error: PropTypes.bool,
};
